import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';
import NewsCard from '@/components/feature/NewsCard';

type LatestNewsProps = {
  items: NewsItem[];
};

export default function LatestNews({ items }: LatestNewsProps) {
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">
              News
            </span>
            <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">最新资讯</h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              影展、访谈、重映与片场动态，第一时间了解相关消息
            </p>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {items.map((item, i) => (
            <NewsCard key={item.id} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}